<template>
  <nav id="bottom-nav" :class="{ 'hide-nav': hideNav, 'is-offline': !isOnline }">
    <div class="bottom-nav-bar">
      <router-link :to="{ name: 'my-card' }" :class="{active : this.$route.name == 'my-card' || this.$route.name == 'my-card-register' }" type="button" class="btn-open-cards">
        <img src="@/assets/svgs/2024/icons/my-card-white.svg" alt="mycard" class="bottom-nav-icon-inactive">
        <img src="@/assets/svgs/2024/icons/my-card-white.svg" alt="mycard" class="bottom-nav-icon-active">
        <span class="bottom-nav-label">{{ this.$t('myCardTitle') }}</span>
      </router-link>
      <button type="button" class="btn-nav-link" :class="{active : this.$route.name == 'bookmarks'}" @click="navigateTo({ name: 'bookmarks' })">
        <img src="@/assets/svgs/2024/icons/heart.svg" alt="bookmarks" class="bottom-nav-icon-inactive">
        <img src="@/assets/svgs/2024/icons/heart-white.svg" alt="bookmarks" class="bottom-nav-icon-active">
        <span class="nav-badge" v-if="bookmarksCount >= 0">{{ bookmarksCount }}</span>
        <span class="bottom-nav-label">{{ this.$t('bookmarksTitle') }}</span>
      </button>
      <button type="button" class="btn-nav-link" :class="{active : this.$route.name == 'news'}" @click="navigateTo({ name: 'news' })">
        <img src="@/assets/svgs/2024/icons/news.svg" alt="news" class="bottom-nav-icon-inactive">
        <img src="@/assets/svgs/2024/icons/news-white.svg" alt="news" class="bottom-nav-icon-active">
        <span class="nav-badge" v-if="newsCount >= 0">{{ newsCount }}</span>
        <span class="bottom-nav-label">{{ this.$t('newsTitle') }}</span>
      </button>
      <season-switch icon-size="1x"/>
    </div>
    <div class="offline-status-bar" :class="{ 'offline-status-bar': true, 'show-status': !isOnline}">
      <font-awesome-icon :icon="['fal', 'wifi-slash']" :style="{ marginRight: '.5rem', fontSize: '.75rem' }"/>
      <span class="bottom-nav-label">{{ this.$t('bookmarksTitle') }}</span>
      {{ $t('offlineInfo') }}
    </div>
    <button id="hovering-button-up" @click="scrollToTopSmooth()">
      <img src="@/assets/svgs/2024/icons/arrow-light-up.svg" alt="ok"></button>
  </nav>
</template>

<script>
import SeasonSwitch from '@/components/SeasonSwitch.vue'

export default {
  name: 'BottomNavigation',
  components: {
    SeasonSwitch
  },
  props: {
    hideNav: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOnline: true
    }
  },
  methods: {
    navigateTo(routeArgs) {
      this.$router.push(routeArgs)
    },
    scrollToTopSmooth() {
      let pos = 0;
      let time = null;

      let currentPos = window.scrollY;
      let start = null;
      if (time == null) time = 500;
      pos = +pos, time = +time;
      window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        var progress = currentTime - start;
        if (currentPos < pos) {
          window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
        } else {
          window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
        }
        if (progress < time) {
          window.requestAnimationFrame(step);
        } else {
          window.scrollTo(0, pos);
        }
      });
    }
  },
  computed: {
    newsCount() {
      return this.$store.getters.getCurrentNews.length
    },
    bookmarksCount() {
      // console.log('bookmarksCount', this.$store.getters.getCurrentBookmarks);
      return this.$store.getters.getCurrentBookmarks.length
    }
  },
  mounted() {
    this.isOnline = navigator.onLine

    this.$eBus.$on('connectionStateChanged', () => {
      this.isOnline = navigator.onLine
    })
  }
}
</script>

<style lang="scss" scoped>
#bottom-nav {
  position: fixed;
  background-color: white;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 15;
  transition: all .2s ease-in-out;
  box-shadow: 0px -1px 2px rgba($black, .10);

  &.is-offline {
    padding-bottom: 1rem;
  }

  // &.hide-nav {
  //     opacity: 0;
  //     visibility: hidden;
  //     z-index: -1;
  // }

  .offline-status-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: .25rem 0;
    text-align: center;
    font-size: .8rem;
    background-color: get-color(primary);
    color: $white;
    transition: all .15s ease-in-out;

    opacity: 0;
    visibility: hidden;
    transform: translate(0, -100%);

    &.show-status {
      opacity: 1;
      visibility: visible;
      transform: translate(0, 0);
    }
  }

  .bottom-nav-bar {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    height: 70px;
    width: 100%;
    max-width: 480px;
    border-top: 1px solid $light-gray;
    margin-left: auto;
    margin-right: auto;

    button,
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img {
        height: 26px;
        width: auto;
      }

      span.bottom-nav-label {
        color: $dark-gray;
        margin-top: 5px;

        @media (max-width: 369px) {
          font-size: 0.8rem;
        }
      }

      &.active,
      &:hover {
        background-color: $dark-gray;
        span.bottom-nav-label {
          color: white;
        }

        .bottom-nav-icon-inactive {
          display: none;
        }
      }
      &:not(.active):not(:hover) {
        .bottom-nav-icon-active {
          display: none;
        }
      }
    }

    .btn-open-cards {
      background-color: $primary-color;
      border: 2px solid $primary-color;
      margin: -20px 2px 0 4px;
      border-bottom: none;
      border-top-right-radius: 20px;
      border-top-left-radius: 20px;
      transition: 0.3s ease all;

      img {
        height: 35px;
        width: 35px;
      }

      span.bottom-nav-label {
        color: white;
      }

      &.active,
      &:hover {
        border-color: $dark-gray;
      }
    }

    .btn-nav-link {
      position: relative;
      cursor: pointer;
      margin: 0 2px;
    }

    .nav-badge {
      position: absolute;
      top: 5px;
      right: calc(50% - 25px);
      display: flex;
      justify-content: center;
      align-items: center;
      width: rem-calc(26);
      height: rem-calc(26);
      background-color: $light-gray;
      color: #005CAA;
      border: 2px solid #005CAA;
      font-size: 1rem;
      font-weight: bold;
      padding: unset;
      border-radius: 50%;
    }

    /*.menu {
      &.app-nav-menu {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 100%;

        .menu-item {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: .5rem;
          font-size: 1.5rem;

          @include breakpoint(medium) {
            font-size: 2rem;
          }
        }
      }
    }*/

    @media screen and (max-width: 450px) {
      .top-bar-center {
        @include xy-cell(12);
        order: 1;
        margin-bottom: 1rem;
      }
      .top-bar-left {
        @include xy-cell(6);
        order: 2;
      }
      .top-bar-right {
        @include xy-cell(6);
        order: 3;
      }
    }
  }
}

#hovering-button-up {
  border: none;
  background-color: rgba($dark-gray, 0.8);
  border-radius: 50%;
  width: 46px;
  height: 46px;
  position: fixed;
  bottom: 85px;
  right: 1rem;
  cursor: pointer;
  transition: 0.3s ease all;
  opacity: 1;

  @media (min-width: 75rem) {
    right: calc(50% - 37rem);
  }

  &:hover {
    bottom: 90px;
  }

  &:not(.scrolled) {
    opacity: 0;
    height: 0;
    width: 0;
  }

  img {
    width: 60%;
    height: auto;
  }
}

</style>
